import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Moment from 'moment'

import Styles from './index.scss'

const Item = props => (
  <tr>
    <td> {parseInt(props.skip, 0) + props.indexKey + 1} </td>
    <td>
      <div className={Styles.containerActions}>
        <Link
          to={`/profiles/${props.row.profileId}`}
          className={`btn btn-icon-only red ${Styles.linkDetail}`}
        >
          <i className="fa fa-eye" />
        </Link>
        <button
          onClick={props.goesToPlatform(props.row.profileId, props.userEmail)}
          className={Styles.btnViewMarketplace}
        >
          <span>View as Super User</span>
        </button>
      </div>
    </td>
    <td> {Moment(`${props.row.createdAt}`).format('MMMM, DD YYYY')} </td>
    <td> {Moment(`${props.row.updatedAt}`).format('MMMM, DD YYYY')} </td>
    <td>
      <span className="capitalize">{props.row.name} </span>
    </td>
    <td>
      <span>
        <Link to={`/profiles/${props.row.profileId}`}>{props.row.profileId}</Link>
      </span>
    </td>
    <td>
      {props.row.subscription?.subscriptionPlan
        ? props.row.subscription.subscriptionPlan.name
        : 'Free'}
    </td>
    <td>
      <span> {props.row.defaultFeature === 'product' ? 'Creator' : 'Client'} </span>
    </td>
    <td>
      <span> {props.row.country.name} </span>
    </td>
    <td>
      <span> {props.row.legacy ? 'Legacy' : 'Default'} </span>
    </td>
  </tr>
)

Item.defaultProps = {
  row: {
    id: '',
    createdAt: '',
    profileId: '',
  },
  skip: 0,
  indexKey: 0,
}

Item.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    profileId: PropTypes.string.isRequired,
    country: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    legacy: PropTypes.bool.isRequired,
    defaultFeature: PropTypes.string.isRequired,
    subscription: PropTypes.shape({
      subscriptionPlan: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
  goesToPlatform: PropTypes.func.isRequired,
  userEmail: PropTypes.string.isRequired,
}

export default Item
